import React from "react";
import { Download } from "lucide-react";
import { TspCard, TspBarChart } from "../../../components/primitives";
import { downloadBookWise } from "../dashboardDownloads";

const formatBookLabel = (name) => {
  if (!name) return "";
  return name
    .replace(/^Srila Prabhupada /i, "SP ")
    .replace(/^Chaitanya Charitamrita/i, "CC")
    .replace(/^Srimad Bhagavatam/i, "SB");
};

// `series` (one per year shown) comes from the caller: the years the server
// returns are always the current and the two before it, but never hardcoded
// here so a year boundary never silently drops a column.
export default function BookWiseChart({ data, series }) {
  const hasBooks = (data || []).length > 0;
  const isMultiItem = (data || []).length > 4;

  return (
    <TspCard
      title="Book Wise Distribution Chart (Count)"
      className="tsp-dashboard-chart-card"
      action={
        <button type="button" className="tsp-download-text-btn" onClick={() => downloadBookWise(data, series)} disabled={!hasBooks} title="Download Excel">
          <Download size={14} /> Download
        </button>
      }
    >
      {hasBooks ? (
        <TspBarChart
          data={data}
          xKey="name"
          series={series}
          height="100%"
          minHeight={isMultiItem ? 260 : 220}
          interval={0}
          angle={isMultiItem ? -40 : undefined}
          textAnchor={isMultiItem ? "end" : "middle"}
          xAxisHeight={isMultiItem ? 60 : 26}
          margin={isMultiItem ? { top: 10, right: 12, left: -14, bottom: 15 } : { top: 10, right: 12, left: -14, bottom: 0 }}
          barSize={isMultiItem ? 10 : 14}
          fontSize={isMultiItem ? 9.5 : 11}
          tickFormatter={formatBookLabel}
        />
      ) : (
        <p className="tsp-muted-text tsp-dashboard-chart-empty">No books distributed yet.</p>
      )}
    </TspCard>
  );
}
